export const environment = {
  production: true,
  trackingId : "UA-118903825-1",
  api : "https://auth.esp.omnissa.com/api/auth/v1",
  espApi: "https://configmax-admin-svc.gid.omnissa.com/",
  espApiLimits: "https://configmax-limits-svc.gid.omnissa.com/",
  cspUrl: 'https://connect.omnissa.com/csp/gateway',
  orgId:"d4bbf546-5072-4cbc-aa81-4a263f81b07d",
  orgLink:"/csp/gateway/am/api/orgs/d4bbf546-5072-4cbc-aa81-4a263f81b07d",
  codeChallenge:"yfnZzZb0fuhyWsVVb9xXsLyV7LDA3A0j-MMNyPGIyhI",
  codeVerifier:"YnFU3stkVtkaJ6gkT-bfMc5PUl1WzRrIv9FKBnwrXChh05-FaV1qZAJgtJkAOKFF6L4m5JvwerJc9oUR1LmR1KRi0a_1_-HD1jbR2gSEylnD6B3O9rRQ0-ij1Yzry7nd",
  clientCSPId:'bkBo2IROqaEkr6c0PcnlnLemE4yJ05L8xgn',
  redirectCSPUri: "https://configmax.omnissa.com/login/auth",
  ssoURL : "https://myvmware-stg.workspaceair.com/SAAS/API/1.0/GET/apps/launch/app/f2e62a99-c45d-4c19-8d36-3b2690c2f775",
  clientId : "esp-prod-428-vlqcn",
  state: "t3jbMJNi",
  authApiUrl: `https://authorization.esp.omnissa.com/api/authorize/v1/permissions/check?client_id=esp-prod-428-vlqcn`,
  espClientId: "configmax-client",
  redirectUri: "/login/auth",
  empAdUrl: "https://employee-ad.esp.eng.omnissa.com/",
  apiLogoutUrl: 'https://auth.esp.omnissa.com/api/auth/v2/logout',
  localizationFilesPath: "https://wp-configuration.esp.omnissa.com/configurationapi/v1/configmax/labels/supportedvalues?locale=",
  whitneyUrl: "https://wp-configuration.esp.omnissa.com",
  whitneyAssetsUrl: "https://wp-configuration.esp.omnissa.com/configurationapi/assetsapi/v1/configmax/asset/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts